import ListItemComponent from '../../../stories/molecules/list-items'
import {
  listItemListViewVariantOptions,
  listItemsCheckVariantOptions
} from '../../../stories/molecules/list-items/constants'
import { CopyMembersTabMembersContainer } from '../../styled-components'
import { iconSizeOptions } from '../../../stories/atoms/icons/icons-sizes'
import LoadingComponent from '../../../async-loader/loading-component'
import { isEmpty } from 'lodash'
import { copyProjectMembersTabOptions } from '../../constants'
import CopyProjectMembersEmpty from '../copy-project-members-empty'
import MemberItem from './member-item'

const checkboxCheckComponent = {
  checkInputType: listItemsCheckVariantOptions.CHECKBOX
}

const MembersList = ({
  members = [],
  isLoading = false,
  searchValue = '',
  selectedItemIds = [],
  onToggleSelect = () => {}
}) => {
  const selectedIdsSet = new Set(selectedItemIds)

  if (isLoading) {
    return <LoadingComponent size={iconSizeOptions['ICON-L']} />
  }

  if (isEmpty(members)) {
    return (
      <CopyProjectMembersEmpty
        variant={copyProjectMembersTabOptions.MEMBERS}
        searchValue={searchValue}
      />
    )
  }

  return (
    <ListItemComponent.Root
      listViewType={listItemListViewVariantOptions.TOGETHER}
      checkComponent={checkboxCheckComponent}
      dividerFull={false}
      hideDivider
    >
      <CopyMembersTabMembersContainer>
        {members.map((item) => {
          return (
            <MemberItem
              key={item.userId}
              item={item}
              isSelected={selectedIdsSet.has(item.userId)}
              onToggleSelect={onToggleSelect}
            />
          )
        })}
      </CopyMembersTabMembersContainer>
    </ListItemComponent.Root>
  )
}

export default MembersList
